var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"read-only",on:{"submit":function($event){$event.preventDefault();return _vm.saveData()}}},[_c('FormBuilder',{attrs:{"fields":_vm.formFields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }